module.exports = __webpack_public_path__ + "img/vasyr-2020.954c1e83.jpg";